/**
 * Payment Util
 */

define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var url = require('util/url.util');

    var paymentUtil = {
        /**
         * Method converts 'headerParameters' from OpenAPI response to convenient form
         * @param  {Object} headerParameters - 'headerParameters' from OpenAPI response
         * @return {Object} Converted 'headerParameters' from OpenAPI
         */
        convertHeaderParameters: function(headerParameters) {
            var getParameterValue = function(paramName, defaultValue) {
                return _.isArray((headerParameters || {})[paramName]) && headerParameters[paramName][0] || defaultValue;
            };

            var location = getParameterValue('Location', '');
            var method = getParameterValue('X-Redirect-Method');
            var content = getParameterValue('X-Redirect-Content');
            var contentType = getParameterValue('X-Redirect-ContentType');
            var transactionCode = getParameterValue('X-Transaction-Code');

            var result = {
                url: location,
                method: 'GET',
                contentType: '',
                postData: {}
            };

            result = _.extend(
                result,
                method === 'POST'
                    ? {
                        method: method,
                        postData: content
                            ? url.getURLParams(content)
                            : result.postData,
                        contentType: contentType || result.contentType
                    }
                    : {
                        url: location && content
                            ? (location.includes('?') ? '&' : '?') + content
                            : result.url
                    }
            );

            if (transactionCode) {
                result.transactionCode = transactionCode;
            }

            return result;
        },

        /**
         * @deprecated use createFormWithHeaderParameters() instead
         */
        getFormFromHeaderParameters: function() {
            return this.createFormWithHeaderParameters.apply(this, arguments);
        },

        /**
         * Method creates form and return it
         * @param {Object} headerParameters - Converted 'headerParameters' from OpenAPI to object with all necessary
         * data for creating form
         * @param {Object} [extraFields] - Extra fields for form
         * @param {Document} [document] - Current document object for creating form in specific window
         */
        createFormWithHeaderParameters: function(headerParameters, extraFields, document) {
            document = document || window.document;

            var form = document.createElement('form');
            var input = document.createElement('input');

            form.action = headerParameters.url;
            form.method = headerParameters.method;
            form.contentType = headerParameters.contentType;
            form.style.display = 'none';

            _.extend(headerParameters.postData, extraFields);

            for (var field in headerParameters.postData) {
                input.name = decodeURIComponent(field);
                input.value = this.preparePostData(input.name, headerParameters.postData[field]);

                form.appendChild(input.cloneNode());
            }

            return form;
        },

        /**
         * Method converts 'postData' to convenient value
         * @param  {string} name
         * @param  {string} postData
         * @return string          Converted 'postData'
         */
        preparePostData: function(name, postData) {
            postData = name === 'PaReq'
                        ? postData
                        : postData.replace(/\+/g, ' ');

            return decodeURIComponent(postData);
        }
    };

    module.exports = paymentUtil;

});
